var Backbone = require('backbone')
  , tmpl = require('./tmpl.handlebars')
  , enableDialog = require('mobile/ui/enableDialog')
  , handleEngageGame = require('mobile/widgets/handleEngageGame')

var View = Backbone.View.extend({
  events: {
    'click .overlay-bt-engage-normal': 'handleEngageNormal',
  }
, initialize: function(options) {
    options = options || {}
    this.gameCode = options.gameCode || {}
    this.gameName = options.gameName || {}
    this.channelType = options.channelType || {}
    this.triggerBtn = options.triggerBtn || {}
  }
, render: function() {
    this.$el.html(tmpl(this.gameName))

    return this
  }
, handleEngageNormal: function(e) {
    e.preventDefault()
    this.trigger('close')
    handleEngageGame(this.gameCode, this.channelType, this.triggerBtn)
  }
})

module.exports = enableDialog(View)
